<template lang="pug">
  div
    #pdf-container(data-cy='pdf-container')
      p(data-cy='error-pdf') {{t("components.forms.error_messages.failed_request")}}
    sofia-contextual-menu-vue(
      :visible='toolbarVisible'
      :x='toolbarX'
      :y='toolbarY'
      :sofiaEnabled='sofiaEnabled'
      @clickSofia='analyzeSelection'
      @clickCopy='copySelection'
    )
  </template>
  
  <script>
  import PDFObject from 'pdfobject'
  import mixins from "common/mixins"
  import { extractQueryParam } from 'common/urlUtils'
  
  export default {
    name: 'pdf-viewer-vue',
    props: {
      path: { type: String, required: true },
      sofiaEnabled: { type: Boolean, default: true }
    },
    mixins: [mixins.requests, mixins.translate],
    components: {
      'sofia-contextual-menu-vue': () => import(
        /* webpackChunkName: "[request]" */ 'components/sofia/SofiaContextualMenu'
      )
    },
    data() {
      return {
        toolbarX: 0,
        toolbarY: 0,
        toolbarVisible: false,
        selectedText: ''
      }
    },
    mounted() {
      this.loadPdfDocument()
    },
    methods: {
      loadPdfDocument() {
        const documentUrl = this.path
        if (documentUrl === undefined) return
  
        let pdfIframe = PDFObject.embed(
          documentUrl,
          '#pdf-container',
          { forcePDFJS: true, PDFJS_URL: this.url_for_pdfjs_library() }
        )
  
        pdfIframe.addEventListener("load", function () {
          const pdfDocument = pdfIframe.contentWindow.document
          pdfDocument.addEventListener('mouseup', (event) => {
            this.toolbarX = event.clientX
            this.toolbarY = event.clientY + document.getElementById('pdf-container').offsetTop + 15
  
            if(this.selectedText!='') {
              this.showContextMenu()
            } else {
              this.hideContextMenu()
            }
          })
  
          pdfDocument.addEventListener('mousedown', (event) => {
            this.hideContextMenu()
          })
  
          pdfDocument.addEventListener("selectionchange", (event) => {
            this.selectedText = pdfDocument.getSelection().toString()
          })
  
          pdfDocument.addEventListener('click', (event) => {
            let targetElement = event.target;
            while (targetElement && targetElement !== this){
              if (targetElement.matches('.linkAnnotation a')){
                this.handleClickLink(event)
                break
              }
              targetElement = targetElement.parentElement;
            }
          });
        }.bind(this))
      },
      handleClickLink(event) {
        const link = event.target
        const pdfLinksParam = extractQueryParam(link.href, 'pdf_links[]')
  
        if (pdfLinksParam.length == 0) return
  
        event.preventDefault()
        this.$emit('link:clicked', pdfLinksParam)
        document.dispatchEvent(
          new CustomEvent(
            'pdfviewer:link-clicked',
            {
              detail:{
                linkParam: pdfLinksParam
              }
            }
          )
        )
      },
      showContextMenu() {
        this.toolbarVisible = true
      },
      hideContextMenu() {
        this.toolbarX = 0,
        this.toolbarY = 0,
        this.toolbarVisible = false,
        this.selectedText = ''
      },
      analyzeSelection() {
        document.dispatchEvent(
          new CustomEvent(
            'pdfviewer:pdf-analize-select',
            {
              detail:{
                text: this.selectedText
              }
            }
          )
        )
        this.hideContextMenu()
      },
      copySelection() {
        document.dispatchEvent(
          new CustomEvent(
            'pdfviewer:pdf-copy-select',
            {
              detail:{
                text: this.selectedText
              }
            }
          )
        )
        this.hideContextMenu()
      }
    }
  }
  </script>
